import { Theme } from '@mui/material';

const toHex = (value: number): string => value.toString(16).padStart(2, '0');

const compositeHexOverWhite = (hexColor: string): string => {
  const hex = hexColor.replace('#', '');
  if (hex.length !== 8) {
    return hexColor;
  }

  const r = Number.parseInt(hex.slice(0, 2), 16);
  const g = Number.parseInt(hex.slice(2, 4), 16);
  const b = Number.parseInt(hex.slice(4, 6), 16);
  const a = Number.parseInt(hex.slice(6, 8), 16) / 255;
  const blend = (channel: number) => Math.round((1 - a) * 255 + a * channel);

  return `#${toHex(blend(r))}${toHex(blend(g))}${toHex(blend(b))}`;
};

export const getOpaqueSurfaceColors = (theme: Theme) => ({
  info: compositeHexOverWhite(theme.palette.surface.info.main),
  error: compositeHexOverWhite(theme.palette.surface.error.main),
  warning: compositeHexOverWhite(theme.palette.surface.warning.main),
  success: compositeHexOverWhite(theme.palette.surface.success.main),
  grey: compositeHexOverWhite(theme.palette.lightGray),
});
